import request from './index'

// 提示语库列表 / List the prompt library
export function getPrompts() {
  return request({
    url: '/user-prompts',
    method: 'get'
  })
}

// 提示语排期概览：当前对所有人生效的提示语 + 默认提示语
// Prompt scheduling overview: the prompt currently active for everyone + the default prompt
export function getCurrentScheduling() {
  return request({
    url: '/user-prompts/current-scheduling',
    method: 'get'
  })
}

// 把一条提示语设为所有人的当前提示语 / Set a prompt as the current one for everyone
export function setCurrentPrompt(data) {
  return request({
    url: '/user-prompts/set-current',
    method: 'post',
    data
  })
}

// 为提示语预约定时生效 / Schedule a prompt to become current at a future time
export function schedulePrompt(data) {
  return request({
    url: '/user-prompts/schedule',
    method: 'post',
    data
  })
}

// 取消定时任务 / Cancel a scheduled activation
export function cancelSchedule(id) {
  return request({
    url: '/user-prompts/schedule/delete/' + id,
    method: 'post'
  })
}

// 新增提示语 / Create a prompt
export function createPrompt(data) {
  return request({
    url: '/user-prompts/save',
    method: 'post',
    data
  })
}

// 编辑提示语：只提交被编辑的字段（content 或 cn_content），另一列保持不变
// Edit a prompt: send only the edited field (content or cn_content); the other is untouched
export function updatePrompt(id, data) {
  return request({
    url: '/user-prompts/update/' + id,
    method: 'post',
    data
  })
}

// 删除提示语 / Delete a prompt
export function deletePrompt(id) {
  return request({
    url: '/user-prompts/delete/' + id,
    method: 'post'
  })
}

// 搜索用户 / Search users
export function searchUsers(keyword) {
  return request({
    url: '/user-prompts/search-users',
    method: 'get',
    params: { keyword }
  })
}

// 把提示语分配给用户 / Assign a prompt to a user
export function assignPrompt(data) {
  return request({
    url: '/user-prompts/assign',
    method: 'post',
    data
  })
}
